import { useState } from 'react'
import { Modal } from './modal'
import { Spinner, SpinnerSize } from '@fluentui/react'
import { toast } from 'react-toastify'
import { MdMailLock } from 'react-icons/md'
import api from '../api-client'
import { errorToString } from '@oneethos/shared'


export const ViewEmailLoginCode = ({ installer }) => {
  const [fetching, setFetching] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [notes, setNotes] = useState('')

  if (installer.active === false) {
    return null
  }

  return <div>
    {showModal ? <Modal dismissable={false}>
      <h3>Request Email Verfication Code</h3>
      <h5>Installer: {installer.email}</h5>
      <div className="alert alert-warning">
        <p className="mb-3">
          ONLY the owner of {installer.email} is allowed to
          request the email code. This option should ONLY be used in the following cases.
        </p>
        <ul>
          <li>
            the owner has been verified using strong authorization
            methods INCLUDING the ability to generally receive email at {installer.email}
          </li>
          <li>the user needs access urgently</li>
          <li>all other methods of troubleshooting have failed</li>
        </ul>
        <div>
          To use this effectively, remember the following:
          <ul>
            <li>
              Every time a user enters their email address and clicks "Email my Login Link",
              a new code is generated and the previous code is no longer valid.
            </li>
            <li>
              Accordingly, you need to ensure they are on the screen for the current login request
              and are actively awaiting the code. 
            </li>
          </ul>  
        </div>
        <p>
          The code should ONLY be shared directly with the user via phone or video
          call, and should NOT be shared with other team members via chat, email, or other
          online communication.
        </p>
        <p>
          Please add notes to confirm details of all of the above before proceeding.
        </p>
      </div>
      <div>
        <textarea
          className="form-control"
          value={notes}
          onChange={e => setNotes(e.target.value)}
          disabled={fetching}
        />
      </div>
      <div className="buttons text-center mt-3">
        {fetching ? <Spinner size={SpinnerSize.small} /> : <>
          <button className="btn btn-primary"
            onClick={() => {
              if (notes?.length > 10) {
                setFetching(true)
                api.post(`/installers/${installer._id}/view-email-login-code`, { notes })
                  .then(res => {
                    setShowModal(false)
                    setNotes('')
                    window.alert(
                      `Email verification code: ${res.code}.
                    
                    If this code does not work, instruct the user to initiate a new login request and try again`
                        .replace(/ {2,}/g, ' ')
                    )
                  })
                  .catch(ex => {
                    setShowModal(false)
                    toast.error(`error viewing email verification code: ${errorToString(ex)}`)
                  }).finally(() => setFetching(false))
              } else {
                toast.error(`Please add enough notes to confirm you have verified the authorization for ${installer.email}.`)
              }
            }}>Retrieve Code</button>
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
        </>}
      </div>
    </Modal> : null}
    <span title="fetch email login code"
      className="ia-trigger"
      onClick={() => setShowModal(true)}>
      <MdMailLock color="#666" />
    </span>
  </div>
}

export default ViewEmailLoginCode